import React from 'react'
import PropTypes from 'prop-types'

import { Box, Checkbox, FormGroup, FormControlLabel, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/pro-regular-svg-icons'

import { ConfirmationDialog } from '@scoir/modals'

export default class TimeZoneInfoModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onDismiss: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
  }
  state = {
    optOut: false,
  }
  updateOptOut(e) {
    this.setState({
      optOut: e.target.checked,
    })
  }

  render() {
    return (
      <ConfirmationDialog
        open={this.props.show}
        onClose={() => {
          this.props.onDismiss()
        }}
        onConfirm={() => {
          this.props.onHide(this.state.optOut)
        }}
        headerText="Just a heads up"
        confirmationText="Got It!"
      >
        <Box
          display="flex"
          alignItems="center"
          mb={3}
        >
          <Box
            color="text.secondary"
            mr={2}
          >
            <FontAwesomeIcon
              icon={faClock}
              size="2x"
            />
          </Box>
          <Typography>
            Events on this calendar are displayed in your current time zone. Click on a slot to view the school&#39;s
            local time.
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography>
            <strong>Bonus feature:</strong> Link your personal calendar (left panel) to display your calendar events
            alongside visit availability. Registered visits can be synced directly to your linked calendar.
          </Typography>
        </Box>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                name="visits-time-zone-confirm-check"
                checked={this.state.optOut}
                onChange={(e) => this.updateOptOut(e)}
                color="primary"
                disableRipple={false}
              />
            }
            label={`Don't show this again.`}
          />
        </FormGroup>
      </ConfirmationDialog>
    )
  }
}
